<template>
  <div class="booking-format-address">
    <el-form-item v-show="notSeaHouseChannelOrWseChannel">
      <el-checkbox
        v-model="manifestInfo.instructBill"
        style="float:right"
        @change="manifestInfo.consigneeEnterpriseName=manifestInfo.instructBill?'TO ORDER':''"
      >{{ $t('SeaExport.ladingBill') }}</el-checkbox>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.consigneeCode')">
      <special-character-tip :texts="specialCharCheck.consigneeShortCode">
        <cargo-input v-model="manifestInfo.consigneeShortCode" :class="importDifferenceField.consigneeShortCode ? 'red-border' : ''" :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterTheEnterpriseCode') : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" label="+" class="label-right">
      <special-character-tip :texts="specialCharCheck.consigneeEnterpriseCode">
        <cargo-input v-model="manifestInfo.consigneeEnterpriseCode" :class="importDifferenceField.consigneeEnterpriseCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="consigneeEnterpriseName" :class="labelStyle" :label="$t('SeaExport.consigneeName')" prop="consigneeEnterpriseName" :rules="[{ validator: validatorConsigneeEnterpriseName, trigger: 'blur' }]">
      <special-character-tip :texts="specialCharCheck.consigneeEnterpriseName">
        <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.consigneeEnterpriseName" :class="importDifferenceField.consigneeEnterpriseName ? 'red-border' : ''" :placeholder="addressTip" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
        <cargo-rich-textarea
          v-else
          v-model="manifestInfo.consigneeEnterpriseName"
          no="consigneeEnterpriseName"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="n"
          auto-half-word
          auto-uppercase
          style="height: 70px;min-height: 70px ; width: 180px"
          :disabled="!isEditing"
          :class="importDifferenceField.consigneeEnterpriseName ? 'red-border' : ''"
          :is-trim="(isSeaHouseChannel || isWseChannel || isRongeTong)"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.consigneeName'),manifestInfo.consigneeEnterpriseName,val=>{manifestInfo.consigneeEnterpriseName=val})"
        />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="consigneeAddress" :class="labelStyle" :label="$t('SeaExport.consigneeDetailAddress')" prop="consigneeAddress" :rules="[{ validator: validatorConsigneeAddress, trigger: 'blur' }]">
      <special-character-tip :texts="specialCharCheck.consigneeAddress">
        <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.consigneeAddress" :class="importDifferenceField.consigneeAddress ? 'red-border' : ''" :placeholder="addressTip2" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
        <cargo-rich-textarea
          v-else
          ref="cargoTextarea1"
          v-model="manifestInfo.consigneeAddress"
          no="consigneeAddress"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="n"
          auto-half-word
          auto-uppercase
          style="height: 110px;width: 180px"
          :disabled="!isEditing"
          :class="importDifferenceField.consigneeAddress ? 'red-border' : ''"
          :is-trim="(isSeaHouseChannel || isWseChannel || isRongeTong)"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.consigneeDetailAddress'),manifestInfo.consigneeAddress,val=>{manifestInfo.consigneeAddress=val})"
        />
      </special-character-tip>
    </el-form-item>
    <el-form-item :class="manifestInfo.consigneeContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" style="display: inline-block;">
      <div style="display: flex;">
        <el-select v-model="manifestInfo.consigneeContactsType" :class="importDifferenceField.consigneeContactsType ? 'require-select red-border' : 'require-select'" style="width:146px" @change="changeContactsType">
          <el-option :label="$t('SeaExport.consigneePhone')" :value="0" />
          <el-option :label="$t('SeaExport.consigneeEmail')" :value="1" />
          <el-option :label="$t('SeaExport.consigneeRelexNumber')" :value="2" />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item ref="consignorPhone" :class="manifestInfo.consigneeContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" prop="consignorPhone" :rules="[{ validator: validatorConsignorPhone, trigger: 'blur' }]" style="display: inline-block;">
      <special-character-tip :texts="specialCharCheck.consigneeContacts">
        <el-tooltip :content="manifestInfo.consigneeContactsType === 0 ?$t('CargoMsg.Cargo_pleaseEnterAPhoneNumber'):''" placement="bottom" effect="light">
          <cargo-input
            v-model="manifestInfo.consigneeContacts"
            :auto-uppercase="true"
            :auto-half-word="true"
            style="width:174px;margin-left:4px;"
            :class="importDifferenceField.consigneeContacts ? 'red-border' : ''"
            :placeholder="manifestInfo.consigneeContactsType === 0 && (isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterAPhoneNumber') : ''"
          />
        </el-tooltip>
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.cityName')">
      <special-character-tip :texts="specialCharCheck.consigneeCityName">
        <cargo-input v-model="manifestInfo.consigneeCityName" :class="importDifferenceField.consigneeCityName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceCode')">
      <special-character-tip :texts="specialCharCheck.consigneeProvinceCode">
        <cargo-input v-model="manifestInfo.consigneeProvinceCode" :class="importDifferenceField.consigneeProvinceCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceName')">
      <special-character-tip :texts="specialCharCheck.consigneeProvinceName">
        <cargo-input v-model="manifestInfo.consigneeProvinceName" :class="importDifferenceField.consigneeProvinceName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.ZipCode')">
      <special-character-tip :texts="specialCharCheck.consigneeZipCode">
        <cargo-input v-model="manifestInfo.consigneeZipCode" :class="importDifferenceField.consigneeZipCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="consigneeCountryCode" :class="labelStyle" :label="$t('CargoMsg.Cargo_CountryRegionCode')" prop="consigneeCountryCode" :rules="[{ validator: validatorConsigneeCountryCode, trigger: 'change' }]">
      <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectACountryCode')" placement="bottom" effect="light">
        <special-character-tip :texts="specialCharCheck.consigneeCountryCode">
          <cargo-input v-if="!isSeaHouseChannel && !isWseChannel && !isRongeTong" v-model="manifestInfo.consigneeCountryCode" :class="importDifferenceField.consigneeCountryCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
          <cargo-advance-select
            v-else
            :static-options="countryList || []"
            :cache="false"
            :default-value="manifestInfo.consigneeCountryCode"
            filterable
            clearable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            :custom-label="(item)=>`[${item.code}]${item.name}`"
            tag-value="code"
            :class="importDifferenceField.consigneeCountryCode ? 'red-border' : ''"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectACountryCode')"
            @parentCallBack="p=>{manifestInfo.consigneeCountryCode=p.value}"
          />
        </special-character-tip>
      </el-tooltip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.aeoEnterpriseCode')">
      <special-character-tip :texts="specialCharCheck.consigneeAeoEnterpriseCode">
        <cargo-input v-model="manifestInfo.consigneeAeoEnterpriseCode" :class="importDifferenceField.consigneeAeoEnterpriseCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.specificContactName')">
      <special-character-tip :texts="specialCharCheck.consigneeSpecificContactsName">
        <cargo-input v-model="manifestInfo.consigneeSpecificContactsName" :class="importDifferenceField.consigneeSpecificContactsName ? 'red-border' : ''" :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterTheActualContactName') : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" label-width="0" class="auto-width">
      <div style="display: flex;">
        <el-select v-model="manifestInfo.consigneeSpecificContactsType" :class="importDifferenceField.consigneeSpecificContactsType ? 'red-border' : ''" style="width:146px">
          <el-option :label="$t('SeaExport.specificContactPhone')" :value="0" />
          <el-option :label="$t('SeaExport.specificContactAddress')" :value="1" />
          <el-option :label="$t('SeaExport.specificContactRelexNumber')" :value="2" />
        </el-select>
        <special-character-tip :texts="specialCharCheck.consigneeSpecificContacts">
          <cargo-input
            v-model="manifestInfo.consigneeSpecificContacts"
            :auto-uppercase="true"
            :auto-half-word="true"
            style="width:174px;margin-left:4px;"
            :class="importDifferenceField.consigneeSpecificContacts ? 'red-border' : ''"
            :placeholder="manifestInfo.consigneeSpecificContactsType === 0 && (isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterAPhoneNumber') : ''"
          />
        </special-character-tip>
      </div>
    </el-form-item>
    <div style="display: flex; justify-content: center; align-items: center;">
      <el-button
        v-show="!notSeaHouseChannelOrWseChannel"
        style="margin-left: 5px;height: 28px;"
        type="primary"
        @click="copyNotifier()"
      >{{ $t('CargoMsg.Cargo_CopyNotifier') }}</el-button>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="!isEditing"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <button
          v-show="isEditing"
          no="advanceTextDialogConfirm"
          type="button"
          class="el-button el-button--default el-button--mini"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</button>
        <button
          no="advanceTextDialogClose"
          class="el-button el-button--default el-button--mini"
          type="button"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import StrUtils from '@/utils/StrUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'

export default {
  name: 'BookingConsigneeFormatAddress',
  components: { cargoRichTextarea, CargoAdvanceSelect, cargoInput, specialCharacterTip },
  props: {
    manifestInfo: { type: Object, required: true },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false },
    countryList: { type: Array, default: () => [] },
    job: { type: Object, default: () => {} },
    showCombinedManifest: { type: Boolean, default: false }
  },
  data() {
    var validatorConsigneeEnterpriseName = (rule, value, callback) => {
      if (this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.consigneeEnterpriseName.length > 0 && this.manifestInfo.consigneeEnterpriseName.length <= 70)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip2')))
        }
      }
    }
    var validatorConsigneeAddress = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.consigneeAddress.length > 0 && this.manifestInfo.consigneeAddress.length <= 140)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip')))
        }
      }
    }
    var validatorConsignorPhone = (rule, value, callback) => {
      if (this.isSeaHouseChannel && this.manifestInfo.consigneeContactsType === 0) {
        if (!this.manifestInfo.consigneeContacts.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      if ((this.isWseChannel || this.isRongeTong) && this.manifestInfo.consigneeContactsType === 0) {
        if (!(this.manifestInfo.consigneeContacts.length > 0 && this.manifestInfo.consigneeContacts.length <= 20)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      return callback()
    }
    var validatorConsigneeCountryCode = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.manifestInfo.consigneeCountryCode.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectACountryCode')))
        }
      }
    }
    return {
      validatorConsigneeEnterpriseName,
      validatorConsigneeAddress,
      validatorConsignorPhone,
      validatorConsigneeCountryCode,
      specialCharCheck: {
        consigneeShortCode: null,
        consigneeEnterpriseCode: null,
        consigneeEnterpriseName: null,
        consigneeAddress: null,
        consigneeContacts: null,
        consigneeCityName: null,
        consigneeProvinceCode: null,
        consigneeProvinceName: null,
        consigneeZipCode: null,
        consigneeCountryCode: null,
        consigneeAeoEnterpriseCode: null,
        consigneeSpecificContactsName: null,
        consigneeSpecificContacts: null
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  computed: {
    labelStyle() {
      return (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) ? 'required-label' : ''
    },
    labelStyle2() {
      return (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) ? 'required-label.mag' : ''
    },
    notSeaHouseChannelOrWseChannel() {
      return !(this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)
    },
    addressTip() {
      if ((this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters2')
      }
      return ''
    },
    addressTip2() {
      if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters')
      }
      return ''
    },
    importDifferenceField() {
      if (this.job) {
        return this.job.differencePrePlanFields || {}
      }
      return {}
    }
  },
  watch: {
    manifestInfo: {
      immediate: true,
      handler() {
        if (this.specialCharacterCheck) {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.manifestInfo[key])
          }
        } else {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = null
          }
        }
      }
    },
    isSeaHouseChannel() {
      this.validate()
    },
    isWseChannel() {
      this.validate()
    },
    isRongeTong() {
      this.validate()
    }
  },
  methods: {
    changeContactsType() {
      this.$refs['consignorPhone'].clearValidate()
    },
    validate() {
      this.$refs['consigneeEnterpriseName'].clearValidate()
      this.$refs['consigneeAddress'].clearValidate()
      this.$refs['consignorPhone'].clearValidate()
      this.$refs['consigneeCountryCode'].clearValidate()
    },
    checkModel(tabName) {
    },
    copyNotifier() {
      this.manifestInfo.consigneeEnterpriseName = this.manifestInfo.notifyEnterpriseName
      this.manifestInfo.consigneeAddress = this.manifestInfo.notifyAddress
      this.manifestInfo.consigneeContactsType = this.manifestInfo.notifyContactsType
      this.manifestInfo.consigneeContacts = this.manifestInfo.notifyContacts
      this.manifestInfo.consigneeCountryCode = this.manifestInfo.notifyCountryCode
      this.validate()
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .booking-format-address{
    /deep/ .required-label {
      .el-form-item__label {
        color: #1F75D5 !important;
      }
      .require-select input{
        color: #1F75D5 !important;
      }
    }
  }
  /deep/ .el-form-item.required-label {
    margin-bottom: 20px !important; /* 设置上下间距 */
  }
  /deep/ .el-form-item.mag {
    margin-bottom: 20px !important; /* 设置上下间距 */
  }

  .red-border {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      border: 1px solid red !important;
    }
  }
</style>
